// AP-style month abbreviations — four letters where the name is long enough
// ("SEPT", not "SEP"), which is what the Figma comps use throughout.
//
// Intl's `{ month: 'short' }` gives "Sep"/"Jun"/"Jul" and is therefore WRONG for
// these designs. This lived as a module-local const in useFindASession.js;
// pulled out here so the seat modals and the find-a-session flow read from one
// list instead of two that can drift.
export const MONTH_ABBR = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUNE', 'JULY', 'AUG', 'SEPT', 'OCT', 'NOV', 'DEC'];

// 0-indexed month → abbreviation, matching Date#getMonth().
export const monthAbbr = (monthIndex) => MONTH_ABBR[monthIndex] ?? '';
